import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Login from "./components/Login";
import Registration from "./components/sign-up/Registration";
import ForgotPassword from "./components/Passwords/ForgotPassword";
import ResetPassword from "./components/Passwords/ResetPassword";

import AdminRoutes from "./routes/AdminRoutes";
import ClientRoutes from "./routes/ClientRoutes";
import EmployeeRoutes from "./routes/EmployeeRoutes";
import CandidateRoutes from "./routes/CandidateRoutes";

import ConfirmAccount from "./components/ClientModule/ConfirmAccount";
import ServiceDown from "./components/service-down/ServiceDown";
import CandidateDashboard from "./components/candidate/CandidateDashboard/candidate-Dashboard";
import ScrollToTop from "./components/ScrollToTop";
import ChatbotWidget from "./components/candidate/chatbotwidget/ChatbotWidget";
import Callback from "./components/candidate/callback/Callback";
import CandidateDetails from "./components/admin/candidate-details/CandidateDetails";
// import PaymentSuccess from "./components/ClientModule/PaymentSuccess/PaymentSuccess";
// import PaymentFailed from "./components/ClientModule/PaymentFailed/PaymentFailed";
import RootRedirect from "./components/RootRedirect";


const HashLinkFixer = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash || ""; 
    if (!hash.startsWith("#/")) return;
    const withoutHash = hash.substring(1); 
    const [hashPath, hashQuery = ""] = withoutHash.split("?");
    const supported = ["/confirm-account"];
    if (supported.includes(hashPath)) {
      const target = `${hashPath}${hashQuery ? `?${hashQuery}` : ""}`;
      window.history.replaceState(null, "", target);
      navigate(target, { replace: true });
    }
  }, [navigate]);

  return null;
};

const AuthSyncHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "forceLogout") {
        navigate("/");
      }

      if(event.key === "logoutEvent"){
        navigate("/");
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [navigate]);

  return null;
};

const SessionTimeoutHandler = () => {
  useEffect(() => {
    const IDLE_TIMEOUT = 30 * 60 * 1000; // 30 mins

    const updateActivity = () => {
      localStorage.setItem(
        "lastActivity",
        Date.now().toString()
      );
    };

    const logoutUser = () => {
      localStorage.removeItem("bgc_token");
      localStorage.removeItem("bgc_refresh_token");
      localStorage.removeItem("authToken");

      //notifing all tabs
      localStorage.setItem(
        "forceLogout",
        Date.now().toString()
      );
      window.location.href = "/";
    };

    const checkIdleTimeout = () => {
      const lastActivity = Number(
        localStorage.getItem("lastActivity")
      );

      if (!lastActivity) {
        return;
      }

      const inactiveTime =
        Date.now() - lastActivity;

      if (inactiveTime >= IDLE_TIMEOUT) {
        logoutUser();
      }
    };

    const events = [
      "mousemove",
      "keydown",
      "click",
      "scroll",
      "touchstart",
    ];

    events.forEach((event) =>
      window.addEventListener(
        event,
        updateActivity
      )
    );

    updateActivity();

    const interval = setInterval(
      checkIdleTimeout,
      60000 // every minute
    );

    return () => {
      clearInterval(interval);

      events.forEach((event) =>
        window.removeEventListener(
          event,
          updateActivity
        )
      );
    };
  }, []);

  return null;
};

const ChatbotWrapper = () => {
  const location = useLocation();
  return location.pathname.startsWith("/candidate") ? <ChatbotWidget /> : null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      
      <HashLinkFixer />

      <AuthSyncHandler />

      <SessionTimeoutHandler />

      <Routes>
        {/* Public */}
        <Route path="/" element={<RootRedirect />} />
        <Route path="/login" element={<Login />} />
        <Route path="/Registration" element={<Registration />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/confirm-account" element={<ConfirmAccount />} />

        {/* Modules */}
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="/client/*" element={<ClientRoutes />} />
        <Route path="/employee/*" element={<EmployeeRoutes />} />
        <Route path="/candidate/*" element={<CandidateRoutes />} />
        <Route path="/client/dashboard/:candidateId" element={<CandidateDashboard />} />
        <Route path="/service-down/:service" element={<ServiceDown />} />
        <Route path="/digilocker/callback" element={<Callback />} />
       <Route path="/candidate-details/:candidateId/*" element={<CandidateDetails />} />
        {/* fallback */}
        <Route path="*" element={<ServiceDown />} />

       
 


      </Routes>
      <ChatbotWrapper />
      <ToastContainer position="top-right" autoClose={3000} />
    </Router>

    
  );
}

export default App;